import { createContext } from 'react';

const authContext = createContext();
// export const useTestFunction = () => useContext(authContext)
export default authContext